export default __webpack_public_path__ + "static/media/flag-rapa-nui.6f166a99.svg";